import { Injectable } from '@angular/core';

@Injectable()
export class DrawingPreviewNavigationService {
  private originalViewBoxHeight: number;
  private originalViewBoxWidth: number;
  private originalViewBoxMinX: number;
  private originalViewBoxMinY: number;

  private currentViewBoxHeight: number;
  private currentViewBoxWidth: number;
  private currentViewBoxMinX: number;
  private currentViewBoxMinY: number;

  private originalViewBox: string;
  private svg: SVGSVGElement;

  private zoomLevel: number;

  private isInitialized: boolean;
  private config: DrawingPreviewNavigationConfig;

  constructor() { }

  setSvg(svg: SVGSVGElement, config: DrawingPreviewNavigationConfig = new DrawingPreviewNavigationConfig()) {
    this.svg = svg;
    this.config = config;
    this.initializeCurrentValues();
  }

  zoomIn() {
    if (!this.isInitialized) {
      return;
    }

    this.currentViewBoxWidth = this.currentViewBoxWidth * this.config.zoomInStep;
    this.currentViewBoxHeight = this.currentViewBoxHeight * this.config.zoomInStep;

    this.svg.setAttribute('viewBox', this.createCurrentViewBoxAttribute());

    this.zoomLevel = this.zoomLevel + 1;
  }

  zoomOut() {
    if (!this.isInitialized || this.zoomLevel === 0) {
      return;
    }

    this.currentViewBoxWidth = this.currentViewBoxWidth * this.config.zoomOutStep;
    this.currentViewBoxHeight = this.currentViewBoxHeight * this.config.zoomOutStep;

    this.svg.setAttribute('viewBox', this.createCurrentViewBoxAttribute());

    this.zoomLevel = this.zoomLevel - 1;
  }

  moveUp() {
    if (!this.isInitialized) {
      return;
    }

    const newMinY = this.currentViewBoxMinY - (this.currentViewBoxHeight * this.config.moveStep);

    this.currentViewBoxMinY = newMinY;
    this.svg.setAttribute('viewBox', this.createCurrentViewBoxAttribute());
  }

  moveDown() {
    if (!this.isInitialized) {
      return;
    }

    const newMinY = this.currentViewBoxMinY + (this.currentViewBoxHeight * this.config.moveStep);

    this.currentViewBoxMinY = newMinY;
    this.svg.setAttribute('viewBox', this.createCurrentViewBoxAttribute());
  }

  moveLeft() {
    if (!this.isInitialized) {
      return;
    }

    const newMinX = this.currentViewBoxMinX - (this.currentViewBoxWidth * this.config.moveStep);

    this.currentViewBoxMinX = newMinX;
    this.svg.setAttribute('viewBox', this.createCurrentViewBoxAttribute());
  }

  moveRight() {
    if (!this.isInitialized) {
      return;
    }

    const newMinX = this.currentViewBoxMinX + (this.currentViewBoxWidth * this.config.moveStep);

    this.currentViewBoxMinX = newMinX;
    this.svg.setAttribute('viewBox', this.createCurrentViewBoxAttribute());
  }

  private initializeCurrentValues() {
    this.isInitialized = false;

    if (!this.svg) {
      return;
    }

    this.originalViewBox = this.svg.getAttribute('viewBox');

    const viewBox = this.originalViewBox.split(' ');

    this.zoomLevel = 0;

    if (viewBox.length === 4) {
      this.originalViewBoxMinX = Number(viewBox[0]);
      this.originalViewBoxMinY = Number(viewBox[1]);
      this.originalViewBoxWidth = Number(viewBox[2]);
      this.originalViewBoxHeight = Number(viewBox[3]);

      this.currentViewBoxMinX = this.originalViewBoxMinX;
      this.currentViewBoxMinY = this.originalViewBoxMinY;
      this.currentViewBoxWidth = this.originalViewBoxWidth;
      this.currentViewBoxHeight = this.originalViewBoxHeight;

      this.isInitialized = true;
    }
  }

  private createCurrentViewBoxAttribute(): string {
    return `${this.currentViewBoxMinX} ${this.currentViewBoxMinY} ${this.currentViewBoxWidth} ${this.currentViewBoxHeight}`;
  }
}

class DrawingPreviewNavigationConfig {
  zoomInStep: number = 0.8;
  zoomOutStep: number = 1.25;
  moveStep: number = 0.25;
}
